// This file is purposely seperate because it imports both react and react-dom
// library. It is more like a helpers file but just do not want to force helpers
// file depend on react-dom.
import React, { PureComponent, useState } from "react";
import ReactDOM from "react-dom/client";
import update from 'immutability-helper';
import { push as _push } from 'connected-react-router';
import { I, L } from './config';
import {
	emptyObject
	, BTN_SAVE_AS_EML
	, C3ERR_SAME_ID
	, PLF_PREVIEW
	, SAVE_AS_EML_STR
	, SEARCH_ERRANDS
	, SEARCH_NEW_ERRANDS
	, SEARCH_MY_ERRANDS
	, SEARCH_CLOSE_ERRANDS
} from "./constants";
import { expireCookie, getCookie, hasPrefix, uuidv4 } from "../helpers";
import { V5 } from '../path';
import { PostForm } from "../../reactcomponents/Form";
import { popupWithMaxDim } from "../../reactcomponents/PopupPage";

export function openPreviewWindowWithPost(url, params) {
	return new Promise((resolve, reject) => {
		const res = window.open("", '_blank');
		if (!res) {
			reject({err: "open window return " + res});
		} else {
			const newDiv = document.createElement("div");
			res.document.body.appendChild(newDiv);
			const elem = ReactDOM.createRoot(newDiv);
			res.addEventListener('beforeunload', e => {
				console.log("window open before unload");
				ReactDOM.unmountComponentAtNode(elem);
			});
			res.addEventListener('load', e => {
				console.log("window open load");
			});
			resolve(elem.render(
				<PostForm params={params} url={url} />
			));
		}
	});
}

const tokenCookieDetectionInterval = 1000
	, tokenCookieDetectionAttempts = 120
	, noTokenCookie = "can't find token cookie after attempts "
		+ tokenCookieDetectionAttempts + " times with interval "
		+ tokenCookieDetectionInterval + " miliseconds per attempt."
	, invisible = {display: "none"}
	, maxSize = {width: "100%", height: "100%"}
	;
class PostLinkBase extends PureComponent {
	constructor(props) {
		super(props);
		this.setRef = this.setRef.bind(this);
	}
	tokenCookieDetection(tokenName, tokenValue) {
		// implementing logic of this suggestion: https://stackoverflow.com/a/4168965/1778714
		let _cancelled = false
			, cookieDetectTimer
			, rejecter
			, previousDoc = this.rootRef.contentDocument
			;
		return [
			new Promise((resolve, reject) => {
				let attempts = tokenCookieDetectionAttempts;
				rejecter = reject;
				cookieDetectTimer = window.setInterval(() => {
					const doc = this.rootRef.contentDocument
						, returnToken = getCookie(doc, tokenName)
						, foundValidToken = returnToken == tokenValue
						;
					if (foundValidToken || attempts == 0) {
						window.clearInterval(cookieDetectTimer);
						expireCookie(doc, tokenName);
						if (foundValidToken) {
							resolve();
						} else {
							reject({reason: noTokenCookie});
						}
						return;
					}
					attempts--;
				}, tokenCookieDetectionInterval);
			})
			, reason => {
				if (!_cancelled) {
					if (cookieDetectTimer) {
						window.clearInterval(cookieDetectTimer);
					}
					_cancelled = true;
					rejecter({isCancelled: true, reason});
				}
			}
		];
	}
	cancelPreviousToken(reason) {
		if (this.cancel) {
			this.cancel(reason);
			this.cancel = null;
		}
	}
	listenEvents(rootRef) {
		$(window).on(
			"message.iframe"
			, ({ originalEvent }) => {
				if (originalEvent && originalEvent.data) {
					const err = originalEvent.data.error;
					if (err) {
						this.cancelPreviousToken(err);
					}
				}
			}
		);
	}
	setRef(ref) {
		this.rootRef = ref;
		this.listenEvents(ref);
	}
	createNativeMountNode() {
		const newDiv = document.createElement("div");
		const elem = ReactDOM.createRoot(newDiv);
		this.elem = elem;
		this.rootRef.contentDocument.body.appendChild(newDiv);
	}
	cleanIframeBody() {
		const body = this.rootRef.contentDocument.body;
		while (body.lastChild) {
			body.removeChild(body.lastChild);
		}
	}
	clearPreviousMountNode() {
		if (!this.elem) {
			return;
		}
		this.cancelPreviousToken("next request start before previous action stop");
		this.cleanIframeBody();
		this.elem = null;
	}
	iframePostForm() {
		this.clearPreviousMountNode();
		this.createNativeMountNode();
		const { token, src } = this.props;
		if (!src) {
			return;
		}
		const { elem } = this
			, { format, data } = src
			, { url } = data
			;
		let params = data.params;
		this.props.onBeforeStart(format);
		if (token) {
			const { field, name } = token
				, value = uuidv4()
				, [ promise, cancel ] = this.tokenCookieDetection(name, value)
				;
			params = update(params, {[field]: {$set: value}});
			this.cancel = cancel;
			promise.then(() => this.props.onEnd())
				.catch(err => this.props.onError(err));
		}
		this.elem.render(
			<PostForm
				loading={format === PLF_PREVIEW}
				params={params}
				url={url}
			/>
		);
	}
	componentDidMount() {
		this.iframePostForm();
	}
	componentDidUpdate(prevProps) {
		if (prevProps.src !== this.props.src) {
			this.iframePostForm();
		}
	}
	componentWillUnmount() {
		$(window).off("message.iframe");
		this.clearPreviousMountNode();
	}
	render() {
		const { src } = this.props;
		let style;
		if (src && src.format === PLF_PREVIEW) {
			style = maxSize;
		} else {
			style = invisible;
		}
		return <iframe ref={this.setRef} style={style} frameBorder="0" />;
	}
}

const downloadToken = {
	field: "download_token"
	, name: "downloadToken"
};

const PostDownload = props => <PostLinkBase token={downloadToken} {...props} />;

const previewButtons = [
	{
		id: BTN_SAVE_AS_EML
		, text: SAVE_AS_EML_STR
	}
];

const Popup = popupWithMaxDim(100);

// TODO: refactor to use createWithPopupWrapper
export const PreviewWithPost = ({ onClick, onClose, show, ...props }) => (
	<Popup
		// TODO: allow save as eml inside preview frame but this requires
		// seperate iframe container.
		// buttons={previewButtons}
		onClick={onClick}
		onClose={onClose}
		show={show}
	>
		<PostLinkBase {...props} />
	</Popup>
);

export const PostIframeLink = props => {
	if (props.src && props.src.format === PLF_PREVIEW) {
		return <PreviewWithPost {...props} />;
	}
	return <PostDownload {...props} />;
};

export const IsContextSearch = (context) =>{
	switch (context) {
		case SEARCH_ERRANDS:
		case SEARCH_NEW_ERRANDS:
		case SEARCH_MY_ERRANDS:
		case SEARCH_CLOSE_ERRANDS:
			return true;
	}
	return false;
}

// like react-router-redux push but more suitable for c3 environment and return
// promise to know if it is V5 page or not.
export const push = (url, ...args) => dispatch => {
	let pathname;
	const urlType = typeof url;
	if (urlType === "string") {
		pathname = url;
	} else if (urlType === "object") {
		pathname = url.pathname;
	}
	if (!pathname || !hasPrefix(pathname, V5)) {
		window.location.href = url;
		return Promise.reject(url);
	}
	dispatch(_push(url, ...args));
	return Promise.resolve(url);
};

export const pushV5 = (context, params) => push(V5, {v5: {context, params}});

// TODO: check where this error come from. It is used by open errand which look
// rather weird and messy.
const customErrorCheck = err => typeof err.err !== "undefined"
	&& typeof err.err.message !== "undefined"
	&& err.err.message.length > 0;

function isSameIDError(err) {
	if (err === C3ERR_SAME_ID) {
		return true;
	} else if (err.sameID) {
		return true;
	}
	return false;
}

function isAbortAJAX(err) {
	if (err.status === 0 && err.statusText === "abort") {
		return true;
	}
	return false;
}

function jsonErrorToString(err, stringify) {
	const messageTypeOf = typeof err.message;
	if (messageTypeOf === "string") {
		return L(err.message);
	} else if (typeof err.error !== "undefined") {
		return L(err.error);
	} else if (messageTypeOf !== "undefined") {
		return L(err.message);
	} else if (stringify) {
		return stringify;
	}
	return err + "";
}

const undefinedError = I("Error is undefined");

export const ERRTYPE_UNDEFINED = 0
	, ERRTYPE_STRING = 1
	, ERRTYPE_FALSY = 2
	, ERRTYPE_OPEN_ERRAND = 3
	, ERRTYPE_RESPONSEJSON = 4
	, ERRTYPE_SAME_ID = 5
	, ERRTYPE_ABORTED_AJAX = 6
	, ERRTYPE_THE_REST = 7 // this MUST be always last item
	;
const arrayErrorHandlers = [
		{ // ERRTYPE_UNDEFINED
			def: false
			, check: err => typeof err === "undefined"
			, msg: () => "undefined error input argument"
		}
		, { // ERRTYPE_FALSY
			def: false
			, check: err => !err
			, msg: err => `error '${err}' is falsy value`
		}
		, { // ERRTYPE_STRING
			def: true
			, check: err => typeof err === "string"
			, msg: err => err
		}
		, { // ERRTYPE_OPEN_ERRAND
			def: true
			, check: err => customErrorCheck(err)
			, msg: err => err.err.message
		}
		, { // ERRTYPE_RESPONSEJSON
			def: true
			, check: err => typeof err.responseJSON !== "undefined"
			, msg: err => jsonErrorToString(err.responseJSON, err.responseText)
		}
		, { // ERRTYPE_SAME_ID
			def: true
			, check: err => isSameIDError(err)
			, msg: ({ sameID }) => `Aborted operation on same ID ${sameID}.`
		}
		, { // ERRTYPE_ABORTED_AJAX
			def: false
			, check: err => isAbortAJAX(err)
			, msg: () => "AJAX request is aborted"
		}
		, { // ERRTYPE_THE_REST
			def: true
			, check: () => true
			, msg: err => jsonErrorToString(err, undefinedError)
		}
	]
	;
function isErrorCheck(modifier, index, def) {
	if (modifier && typeof modifier[index] !== "undefined") {
		return !!modifier[index];
	}
	return def;
}

export function analyzeError(err, custom) {
	const lastIndex = arrayErrorHandlers.length - 1;
	for (let i=0; i<lastIndex; i++) {
		const { def, check, msg } = arrayErrorHandlers[i];
		if (check(err)) {
			return [isErrorCheck(custom, i, def), msg(err)];
		}
	}
	const { def, check, msg } = arrayErrorHandlers[lastIndex];
	return [isErrorCheck(custom, lastIndex, def), msg(err)];
}

export function getMinutesBetweenDates(startDate, endDate) {
    var diff = endDate.getTime() - startDate.getTime();
    return (diff / 60000);
}

export function ClipboardCopy({ copyText }) {
	const [isCopied, setIsCopied] = useState(false);
	async function copyTextToClipboard(text) {
		if ('clipboard' in navigator) {
			return await navigator.clipboard.writeText(text);
		} else {
			return document.execCommand('copy', true, text);
		}
	}
	const handleCopyClick = () => {
		copyTextToClipboard(copyText)
		.then(() => {
			setIsCopied(true);
			setTimeout(() => {
				setIsCopied(false);
			}, 1500);
		})
		.catch((err) => {
			console.log(err);
		});
	}

	return (<div>
			<i className="icon-copy" title={I('Copy answer')} onClick={handleCopyClick}></i>
			<span>{isCopied ? I('Copied!') : ''}</span>
	</div>);
}

export function copyPlainTextToClipboard(text, isFormatted = false) {
	const tempElement = document.createElement('div');
	if (isFormatted) {
		tempElement.innerHTML = text;
	} else {
		tempElement.textContent = text;
	}
	document.body.appendChild(tempElement);

	const range = document.createRange();
	range.selectNodeContents(tempElement);
	const selection = window.getSelection();
	selection.removeAllRanges();
	selection.addRange(range);

	const copySuccess = () => {
		console.log('Text copied to clipboard');
		document.body.removeChild(tempElement);
	};

	const copyFail = (err) => {
		console.error('Error copying text:', err);
		document.body.removeChild(tempElement);
	};

	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(selection.toString())
			.then(copySuccess)
			.catch(copyFail);
	} else {
		try {
			document.execCommand('copy');
			copySuccess();
		} catch (err) {
			copyFail(err);
		}
	}
}

export function copyTextToClipboard(text) {
	const tempElement = document.createElement('div');
	tempElement.innerHTML = text;
	document.body.appendChild(tempElement);

	const range = document.createRange();
	range.selectNodeContents(tempElement);
	const selection = window.getSelection();
	selection.removeAllRanges();
	selection.addRange(range);

    if (selection.rangeCount > 0) {
        const container = document.createElement('div');
        container.appendChild(range.cloneContents());
        const htmlContent = container.innerHTML; // Get HTML content
        const textContent = selection.toString(); // Get plain text

        // Check if the Clipboard API supports writing HTML
        if (navigator.clipboard && navigator.clipboard.write) {
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const textBlob = new Blob([textContent], { type: 'text/plain' });

            const clipboardItem = new ClipboardItem({
                'text/html': blob,
                'text/plain': textBlob,
            });

            navigator.clipboard.write([clipboardItem]).then(() => {
                console.log('Formatted content copied to clipboard!');
            }).catch((err) => {
                console.error('Failed to copy:', err);
            });
        } else {
            console.error('Clipboard API does not support writing HTML.');
        }
    } else {
        console.error('No selection found to copy!');
    }
}

export function copyAllTextToClipboard(text) {
	const tempElement = document.createElement('div');
	tempElement.innerHTML = text;
	document.body.appendChild(tempElement);

	const range = document.createRange();
	range.selectNodeContents(tempElement);
	const selection = window.getSelection();
	selection.removeAllRanges();
	selection.addRange(range);

	if (selection.rangeCount > 0) {
		const container = document.createElement('div');
		container.appendChild(range.cloneContents());
		const htmlContent = container.innerHTML; // Get HTML content
		const textContent = selection.toString(); // Get plain text

		// Check if the Clipboard API supports writing HTML
		if (navigator.clipboard && navigator.clipboard.write) {
			const blob = new Blob([htmlContent], { type: 'text/html' });
			const textBlob = new Blob([textContent], { type: 'text/plain' });

			const clipboardItem = new ClipboardItem({
				'text/html': blob,
				'text/plain': textBlob,
			});

			navigator.clipboard.write([clipboardItem]).then(() => {
				console.log('Formatted content copied to clipboard!');
			}).catch((err) => {
				console.error('Failed to copy:', err);
				// Fallback to plain text if HTML copying fails
				navigator.clipboard.writeText(textContent);
			});
		} else {
			// Fallback for browsers that don't support ClipboardItem
			console.warn('Clipboard API does not support writing HTML, falling back to plain text.');
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(textContent);
			} else {
				// Final fallback using execCommand
				try {
					document.execCommand('copy');
					console.log('Text copied using execCommand fallback');
				} catch (err) {
					console.error('All clipboard methods failed:', err);
				}
			}
		}
	} else {
		console.error('No selection found to copy!');
	}

	document.body.removeChild(tempElement);
}


// Generate Integrity Hash for script using SHA-384
export async function generateIntegrityHash(url, algorithm = 'SHA-384') {
	const response = await fetch(url);

	if (!response.ok) {
		throw new Error(`Failed to load ${url} (HTTP status: ${response.status})`);
	}

	const blob = await response.blob();
	const data = await new Response(blob).arrayBuffer();
	const hashBuffer = await crypto.subtle.digest({ name: algorithm }, data);

	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const base64Hash = btoa(String.fromCharCode.apply(null, hashArray));
	return "sha384-"+ base64Hash;
}

// Create Integrity Attribute
export async function createIntegrityAttr(src) {
	try {
		const hash = await generateIntegrityHash(src);
		return hash;
	} catch (error) {
		console.error(error);
		return ''; // Return an empty string or handle the error as needed
	}
}

// Element detection if element is at bottom of parent
export const isElementAtBottom = (elem, pa) => {
	if(pa) {
		const element = elem.current;
		const parent = pa.current;
		// Check if the element and its parent exist
		if (element && parent) {
			const elementRect = element.getBoundingClientRect();
			const parentRect = parent.getBoundingClientRect();
			const distanceToBottom = parentRect.bottom - elementRect.bottom;
			// Adjust the threshold as needed
			const threshold = 10; // Adjust this value based on your requirement
			return distanceToBottom <= threshold;
		} else {
			return false;
		}
	}
	return false;
};

export const isEmptyString = str => /^\s*$/.test(str);

/**
 * Converts a color string to RGB values
 * @param {string} color - Color in various formats (hex, rgb, rgba, named colors)
 * @returns {Object|null} - Object with r, g, b values or null if parsing fails
 */
function parseColorToRGB(color) {
	if (!color || color === 'transparent' || color === 'inherit' || color === 'initial') {
		return null;
	}

	// Handle hex colors
	if (color.startsWith('#')) {
		const hex = color.slice(1);
		if (hex.length === 3) {
			return {
				r: parseInt(hex[0] + hex[0], 16),
				g: parseInt(hex[1] + hex[1], 16),
				b: parseInt(hex[2] + hex[2], 16)
			};
		} else if (hex.length === 6) {
			return {
				r: parseInt(hex.substr(0, 2), 16),
				g: parseInt(hex.substr(2, 2), 16),
				b: parseInt(hex.substr(4, 2), 16)
			};
		}
	}

	// Handle rgb/rgba colors
	const rgbMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
	if (rgbMatch) {
		return {
			r: parseInt(rgbMatch[1], 10),
			g: parseInt(rgbMatch[2], 10),
			b: parseInt(rgbMatch[3], 10)
		};
	}

	// Handle named colors by creating a temporary element
	const tempEl = document.createElement('div');
	tempEl.style.color = color;
	document.body.appendChild(tempEl);
	const computedColor = window.getComputedStyle(tempEl).color;
	document.body.removeChild(tempEl);

	if (computedColor !== color) {
		return parseColorToRGB(computedColor);
	}

	return null;
}

/**
 * Calculates the relative luminance of a color
 * @param {Object} rgb - Object with r, g, b values
 * @returns {number} - Luminance value between 0 and 1
 */
function calculateLuminance(rgb) {
	const { r, g, b } = rgb;
	const [rs, gs, bs] = [r, g, b].map(c => {
		c = c / 255;
		return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
	});
	return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

/**
 * Calculates contrast ratio between two colors
 * @param {Object} color1 - RGB object for first color
 * @param {Object} color2 - RGB object for second color
 * @returns {number} - Contrast ratio
 */
function calculateContrastRatio(color1, color2) {
	const lum1 = calculateLuminance(color1);
	const lum2 = calculateLuminance(color2);
	const lighter = Math.max(lum1, lum2);
	const darker = Math.min(lum1, lum2);
	return (lighter + 0.05) / (darker + 0.05);
}

/**
 * Determines if a color would be readable on a white background
 * @param {string} color - Color string to check
 * @returns {boolean} - True if readable, false if needs adjustment
 */
function isReadableOnWhite(color) {
	const whiteRGB = { r: 255, g: 255, b: 255 };
	const colorRGB = parseColorToRGB(color);

	if (!colorRGB) {
		return true; // If we can't parse the color, assume it's readable
	}

	const contrastRatio = calculateContrastRatio(colorRGB, whiteRGB);
	return contrastRatio >= 4.5; // WCAG AA standard for normal text
}

/**
 * Gets a readable alternative color for text on white background
 * @param {string} originalColor - Original text color
 * @returns {string} - Adjusted color that's readable on white
 */
function getReadableColorForWhite(originalColor) {
	if (isReadableOnWhite(originalColor)) {
		return originalColor;
	}

	const colorRGB = parseColorToRGB(originalColor);
	if (!colorRGB) {
		return '#000000'; // Default to black if parsing fails
	}

	// If the color is too light, make it darker
	const luminance = calculateLuminance(colorRGB);
	if (luminance > 0.5) {
		// Color is light, make it dark
		return '#333333'; // Dark gray instead of pure black for better readability
	}

	// If we reach here, return the original color
	return originalColor;
}

/**
 * Cleans pasted HTML content by removing background-related styles and attributes.
 * This utility function strips background colors, images, and other background properties
 * from pasted content while preserving other formatting. It also adjusts text colors
 * that might become unreadable on white backgrounds after background removal.
 *
 * @param {string} htmlContent - The HTML content to clean
 * @returns {string} - The cleaned HTML content without background properties and with readable text colors
 */
export function cleanPastedContent(htmlContent) {
	if (!htmlContent || typeof htmlContent !== 'string') {
		return htmlContent;
	}

	// Create a temporary container to parse and clean the HTML
	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = htmlContent;

	// Add the temporary div to the document to get computed styles
	tempDiv.style.visibility = 'hidden';
	tempDiv.style.position = 'absolute';
	tempDiv.style.top = '-9999px';
	document.body.appendChild(tempDiv);

	try {
		// Remove background-related styles from all elements and adjust text colors
		const elements = tempDiv.querySelectorAll('*');
		elements.forEach(el => {
			// Get the current computed styles before removing background
			const computedStyle = window.getComputedStyle(el);
			const backgroundColor = computedStyle.backgroundColor;
			const textColor = computedStyle.color;

			if (el.style) {
				// Check if the text color needs adjustment based on background removal
				const backgroundRGB = parseColorToRGB(backgroundColor);
				if (backgroundRGB) {
					// If background exists and text color might become unreadable on white
					if (!isReadableOnWhite(textColor)) {
						el.style.color = getReadableColorForWhite(textColor);
					}
				}

				// Remove background-related properties
				el.style.removeProperty('background');
				el.style.removeProperty('background-color');
				el.style.removeProperty('background-image');
				el.style.removeProperty('background-position');
				el.style.removeProperty('background-repeat');
				el.style.removeProperty('background-size');
				el.style.removeProperty('background-attachment');
				el.style.removeProperty('background-origin');
				el.style.removeProperty('background-clip');

				// If style attribute is empty after removing properties, remove it entirely
				if (!el.style.cssText || el.style.cssText.trim() === '') {
					el.removeAttribute('style');
				}
			}

			// Also remove any bgcolor attribute (legacy HTML)
			if (el.hasAttribute('bgcolor')) {
				el.removeAttribute('bgcolor');
			}
		});

		// Return the cleaned HTML content
		return tempDiv.innerHTML;
	} finally {
		// Always remove the temporary element
		document.body.removeChild(tempDiv);
	}
}

/**
 * Handles CKEditor paste events by cleaning background properties from pasted content.
 * This function prevents the default paste behavior and inserts cleaned content instead.
 * Additionally applies font styling to the pasted content if font parameters are provided.
 *
 * @param {Object} event - The CKEditor paste event object
 * @param {string} [fontFamily] - Optional font family to apply to pasted content
 * @param {string} [fontSize] - Optional font size to apply to pasted content
 * @returns {boolean} - Returns false if content was processed, true to allow default behavior
 */
export function handleCKEditorPaste(event, fontFamily, fontSize) {

	if (!event || !event.data || !event.data.dataValue) {
		return true; // Allow default behavior if no data
	}

	// Prevent default paste to process the content
	event.stop();

	// Get the pasted HTML content
	const pastedContent = event.data.dataValue;

	// Clean the content
	let cleanedContent = cleanPastedContent(pastedContent);

	// Apply font styles if provided (ignore empty strings)
	if (fontFamily && fontFamily.trim() !== '') {
		const styleAttributes = [];
		if (fontFamily && fontFamily.trim() !== '') {
			styleAttributes.push(`font-family: ${fontFamily}`);
		}
		if (styleAttributes.length > 0) {
			const styleString = styleAttributes.join('; ');
			cleanedContent = `<span style="${styleString}">${cleanedContent}</span>`;
		}
	}

	// Insert the cleaned content into the editor
	if (event.editor && event.editor.insertHtml) {
		event.editor.insertHtml(cleanedContent);
	} else if (event.editor && event.editor.execCommand) {
		// Fallback: try to use CKEditor's execCommand
		event.editor.execCommand('insertHtml', cleanedContent);
	}

	return false; // Prevent default paste behavior
}
